import { AUTH_ACTION } from '@bluheadless/ui-logic/src/constants'
import withAuthUserSSR from '@bluheadless/ui-logic/src/hof/withAuthUserSSR'
import GuestOrderPageComponent from '@bluheadless/ui/src/page-components/customer/guest/guest-order'
import { getDynamicAreas } from 'data-api'
import Head from 'next/head'
import { useIntl } from 'react-intl'

const GuestOrder = (props) => {
	const { formatMessage } = useIntl()

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'guest_order_meta_title' })}</title>
			</Head>
			<GuestOrderPageComponent {...props} />
		</>
	)
}

export default GuestOrder

const _getServerSideProps = async ({ req }) => {
	const dynamicAreas = (
		await getDynamicAreas({
			client: req.__bh__client,
			dynamicAreasDisplayEntity: 'service_pages',
			dynamicAreasId: 'guest_order',
		})
	).data

	return { props: { dynamicAreas } }
}

export const getServerSideProps = withAuthUserSSR(
	{
		whenAuthenticated: AUTH_ACTION.REDIRECT_TO_ACCOUNT,
		whenUnauthenticated: AUTH_ACTION.RENDER,
	},
	async ({ req }) => {
		const {
			catalog: { disableShop },
			checkout: { disableGuest },
		} = req.__bh__config

		if (disableShop || disableGuest) {
			return { notFound: true }
		} else {
			return await _getServerSideProps({ req })
		}
	}
)

GuestOrder.layout = { cssClass: 'guest-order-page' }
